// extracted by mini-css-extract-plugin
export default {"root":"VerifyEmailForm_root__xe8MV","emailInput":"VerifyEmailForm_emailInput__Ue0JI"};